import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTable } from "@angular/material/table";
import { PatientReplyComponent } from "../../common/patient-reply/patient-reply.component";
import { ApiService } from "../../common/services/api.service";

@Component({
    selector: "app-patient-account",
    templateUrl: "./patient-account.component.html",
    styleUrls: ["./patient-account.component.scss"],
})
export class PatientAccountComponent implements OnInit {
    patientBookings: any[] = [];
    internationalServices: any[] = [];

    nationalColumnsToDisplay = [
        "id",
        "name",
        "nationalID",
        "requestDate",
        "status",
        "reply",
    ];

    @ViewChild("table", { static: true }) table: MatTable<any>;

    constructor(private dialog: MatDialog, private apiService: ApiService) {
        this.fillBookings();
    }

    ngOnInit(): void {}

    reply(booking) {
        const dialogRef = this.dialog.open(PatientReplyComponent, {
            minWidth: "700px",
            data: { booking: booking },
            minHeight: "50%",
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                console.log(result);
                if (result.action == true) {
                    this.apiService
                        .userReply(
                            result.file,
                            result.message,
                            booking.havemessage
                        )
                        .subscribe((res) => {
                            console.log(res);
                        });
                }
                console.log("OK");

                console.log("Ssssss");

                this.table.renderRows();
            }
        });

        //console.log(this.dataSource)
    }

    fillBookings() {
        this.apiService.getPatientBookings().subscribe((res: any) => {
            console.log(res);
            this.patientBookings = res["data"];
            this.table.renderRows();
        });
    }
}
